var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid mb-1", attrs: { id: "internet-offers" } },
    [
      _c("div", { staticClass: "row px-1 mb-2" }, [
        _c("div", { staticClass: "col-12 px-0" }, [
          _c("h2", {
            staticClass: "h3 mb-md-2 mb-1",
            domProps: { innerHTML: _vm._s(_vm.internetOffersData.titleHtml) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 px-0 mb-2" }, [
          _vm.internetOffersData.tagWithoutEquipmentLabel
            ? _c("span", { staticClass: "ob1-filterchip pe-2" }, [
                _c("input", {
                  staticClass: "ob1-filterchip-input visually-hidden",
                  attrs: { id: "tag1", type: "checkbox" },
                  domProps: {
                    checked:
                      _vm.internetOffersFilter != null &&
                      !_vm.internetOffersFilter,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.updateFilterEquipment(false)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "ob1-filterchip-label",
                  attrs: { for: "tag1" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.internetOffersData.tagWithoutEquipmentLabel
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.internetOffersData.tagWithEquipmentLabel
            ? _c("span", { staticClass: "ob1-filterchip" }, [
                _c("input", {
                  staticClass: "ob1-filterchip-input visually-hidden",
                  attrs: { id: "tag2", type: "checkbox" },
                  domProps: {
                    checked:
                      _vm.internetOffersFilter != null &&
                      _vm.internetOffersFilter,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.updateFilterEquipment(true)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "ob1-filterchip-label",
                  attrs: { for: "tag2" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.internetOffersData.tagWithEquipmentLabel
                    ),
                  },
                }),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 px-0" }, [
          _c("div", { staticClass: "container mw-100" }, [
            _c("div", { staticClass: "row px-0" }, [
              _c(
                "div",
                { staticClass: "col-12 px-0" },
                [
                  _c(
                    "swiper-container",
                    {
                      attrs: {
                        "uniq-swiper-id": "internetOffersSwiper1",
                        "slides-per-view": _vm.swiperSlidesPerView,
                        "space-between": _vm.swiperSpaceBetween,
                        pagination: _vm.swiperPagination,
                        navigation: _vm.swiperNavigation,
                        "update-navigation-position-in-screen":
                          _vm.swiperUpdateNavigationPositionInScreen,
                        "padding-bottom-in-px": _vm.swiperPaddingBottomInPx,
                        breakpoints: _vm.swiperBreakpoints,
                      },
                      on: { "after-swiper-update": _vm.afterSwiperUpdate },
                    },
                    [
                      _vm._l(
                        _vm.internetOffersTilesWithUpdatedDetailPageUrl,
                        function (offer, offerIndex) {
                          return _c(
                            "swiper-slide",
                            {
                              key: offer.id,
                              staticStyle: { height: "auto" },
                              attrs: {
                                "is-initial-swiper-slide":
                                  offer.seoId ===
                                  _vm.selectedInternetOfferSeoId,
                              },
                            },
                            [
                              _c("new-internet-offer-tile", {
                                key: offer.seoId,
                                attrs: {
                                  offer: offer,
                                  "is-selected":
                                    offer.seoId ===
                                    _vm.selectedInternetOfferSeoId,
                                  "offer-tile-index": offerIndex,
                                  "show-detail-page":
                                    _vm.internetOffersData.showOfferDetailPage,
                                },
                                on: { "select-offer": _vm.selectOffer },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.internetOffersAnimationsTiles,
                        function (internetOffersAnimationTile) {
                          return _c(
                            "swiper-slide",
                            {
                              key: internetOffersAnimationTile.id,
                              staticStyle: { height: "auto" },
                            },
                            [
                              _c("internet-push-animation-tile", {
                                attrs: {
                                  "push-animation": internetOffersAnimationTile,
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        !_vm.internetOffersData.eligibilityResult
          ? _c("div", { staticClass: "col-12 px-0 pt-1" }, [
              _c("a", {
                staticClass: "ob1-link-arrow ob1-link-large",
                attrs: {
                  href: _vm.internetOffersData.alternateLink.link,
                  "data-oevent-category":
                    _vm.internetOffersData.alternateLink.tms.category,
                  "data-oevent-action":
                    _vm.internetOffersData.alternateLink.tms.action,
                  "data-oevent-label":
                    _vm.internetOffersData.alternateLink.tms.label,
                },
                domProps: {
                  innerHTML: _vm._s(_vm.internetOffersData.alternateLink.label),
                },
              }),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }